// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"c0307b14","425":"46a0a8d1","510":"ff196c26","532":"414d80e7","633":"04914921","634":"fcacbf97","922":"94517768","937":"9886eb71","972":"092b7325"}[chunkId] + ".chunk.js";
};